import { TenantRow } from '../types';

let rowIdCounter = 0;

const createRowId = () => `tenant-row-${++rowIdCounter}`;

export const createEmptyRow = (): TenantRow => ({
  id: createRowId(),
  key: '',
  value: ''
});

export const createRowFromTenant = (key: string, value: string): TenantRow => ({
  id: createRowId(),
  key,
  value
});
